import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { replaceByLinkEnv } from 'services/formatter';
import { tabContext } from 'contexts/tabContext';
import { SIZE_GUIDE_TAB_ID } from 'settings/productV2';
import styles from './ProductReassurance.module.scss';

/**
 * Product page of website. Contains reassurance product block.
 */
function ProductReassurance({
  htmlContent,
}: {
  htmlContent: string;
}): JSX.Element {
  const { setIdTab, scrollToTabs } = useContext(tabContext);
  const { t } = useTranslation();

  function onClick(e: React.MouseEvent<HTMLDivElement>) {
    if ((e.target as Element).closest('#sizeguidelink')) {
      e.preventDefault();
      setIdTab(SIZE_GUIDE_TAB_ID);
      scrollToTabs(SIZE_GUIDE_TAB_ID);
    }
  }

  return (
    <>
      <div className={styles.reassurance}>
        <div
          onClick={onClick}
          dangerouslySetInnerHTML={{
            __html: replaceByLinkEnv(htmlContent, {
              '@@follow_guide_update@@': t('LABEL_FOLLOW_GUIDE_UPDATE'),
            }),
          }}
        />
      </div>
    </>
  );
}

export default ProductReassurance;
